/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { log } from 'src/consoleManager';
import postBeacon from 'src/networkManager';
import { getKeyNameStoreData, updateStoreData } from 'src/storage';
import { getAppSessionId, secondsToDays, getNextDateTime } from 'src/utils';
import { SESSION_KEY_STORAGE_TYPE, SESSION_STORAGE_TYPE } from 'src/utils/enum';
import { getSDKConfig } from 'src/utils/config';
let batchMaxRetriesCount = 3; // Number of retries for priority events from
let batchRemainingRetriesCount = 3;
let batchRetryBackoff = 500; // Retry delay in milliseconds (2 second)
let batchDiscardOnFailure = false; // Do not discard priority events if retries fail
let batchInterval = 300000; // Interval for batching events in seconds (5 minutes)`
let batchMaxBeaconsPerMinute = 120; // Maximum number of beacons allowed per minute
let batchOfflineCacheFlushInterval = 7; //Flush offline cache every 7 days in seconds

const batchedProcessQueue = () => {
  if (
    window.spnGlobalConfig.spnBeaconNetworkStatus &&
    window.spnGlobalConfig.batchedBeaconExecutionStart == false
  ) {
    batchConfigUpdate();
    batchedExecuteLocalStorage();
  }
};

const batchConfigUpdate = () => {
  const sdkConfig = getSDKConfig();
  batchMaxRetriesCount = sdkConfig?.batch?.max_retries || 3;
  batchRemainingRetriesCount = sdkConfig?.batch?.max_retries || 3;
  batchRetryBackoff = sdkConfig?.batch?.retry_backoff || 500;
  batchDiscardOnFailure = sdkConfig?.batch?.discard_on_failure || false;
  batchInterval = sdkConfig?.batch?.batch_interval || 300000;
  const OfflineDays = sdkConfig.batch?.offline_cache_flush_interval || 604800;
  const finalDays = secondsToDays(OfflineDays);
  batchOfflineCacheFlushInterval = OfflineDays;
  batchMaxBeaconsPerMinute =
    sdkConfig?.general?.rate_limit?.max_beacons_per_minute || 120;
  if (sdkConfig?.general?.rate_limit?.enabled == true) {
    const burstLimit = sdkConfig?.general?.rate_limit?.burst_limit || 50;
    batchMaxBeaconsPerMinute += burstLimit;
  }
  batchRemainingRetriesCount -= 1;
};

// current storage Execution
const batchedExecuteLocalStorage = () => {
  try {
    if (
      window.spnGlobalConfig?.maxRecordPerMinute >= batchMaxBeaconsPerMinute
    ) {
      window.spnGlobalConfig.batchedBeaconExecutionStart = true;
      return;
    }
    if (!window.spnGlobalConfig.spnBeaconNetworkStatus) {
      return;
    }
    if (window.spnGlobalConfig.batchedBeaconExecutionStart) {
      return;
    }
    const sessionId = SESSION_STORAGE_TYPE.batched + getAppSessionId();
    const currentStoredata = localStorage.getItem(sessionId);
    const localStorageData = currentStoredata
      ? JSON.parse(currentStoredata)
      : [];
    if (localStorageData.length == 0) {
      window.spnGlobalConfig.batchedBeaconExecutionStart = true;
      return;
    }

    const currentTime = parseInt(localStorageData[0].currentTime);
    const payLoadBody = localStorageData[0].payLoadBody;
    const eventType = localStorageData[0].eventType;
    const offlineCacheNextDate = getNextDateTime(
      currentTime,
      batchOfflineCacheFlushInterval
    );
    // offline cache time calculate
    if (currentTime > offlineCacheNextDate) {
      // remove from queue when current time greater then offline time
      const apiResponse = 200;
      batchedCleanCurrentSessionBeacons(apiResponse, sessionId);
      batchedHandleCurrentSessionNextBeaconExecute(apiResponse, sessionId);
    } else {
      const networkPromise = postBeacon(payLoadBody, eventType);
      networkPromise
        .then((apiResponse) => {
          batchedCleanCurrentSessionBeacons(apiResponse, sessionId);
          batchedHandleCurrentSessionNextBeaconExecute(apiResponse, sessionId);
        })
        .catch((e) => {
          log(e);
          if (
            window.spnGlobalConfig.spnBeaconNetworkStatus ||
            window?.navigator?.onLine
          ) {
            const apiResponse = 0;
            batchedCleanCurrentSessionBeacons(apiResponse, sessionId);
            batchedHandleCurrentSessionNextBeaconExecute(
              apiResponse,
              sessionId
            );
            //window.spnGlobalConfig.batchedBeaconExecutionStart = true;
          }
        });
    }
  } catch (e) {
    log(e);
    window.spnGlobalConfig.batchedBeaconExecutionStart = true;
  }
};

const batchedCleanCurrentSessionBeacons = (apiResponse, sessionId) => {
  try {
    //apiResponse == 200 || apiResponse == 0 &&
    const removeFromQueue = getBatchRecordRemoveStatus(apiResponse);
    if (removeFromQueue) {
      const currentStoredata = localStorage.getItem(sessionId);
      const localStorageData = currentStoredata
        ? JSON.parse(currentStoredata)
        : [];
      if (localStorageData.length > 0) {
        localStorageData.shift();
        updateStoreData(sessionId, localStorageData);
      }
    }
  } catch (error) {
    log(error);
  }
};

const batchedHandleCurrentSessionNextBeaconExecute = (
  apiResponse,
  sessionId
) => {
  try {
    if (apiResponse == 200 || apiResponse == 0) {
      window.spnGlobalConfig.maxRecordPerMinute += 1;
      let intervalTime = 5000;
      if (apiResponse == 200) {
        intervalTime = batchInterval;
      } else if (apiResponse == 0) {
        intervalTime = batchRetryBackoff;
      }
      // when beacons pass
      const currentStoredata = localStorage.getItem(sessionId);
      const localStorageData = currentStoredata
        ? JSON.parse(currentStoredata)
        : [];
      if (
        localStorageData.length > 0 &&
        window.spnGlobalConfig.batchedBeaconExecutionStart == false
      ) {
        setTimeout(() => {
          batchedExecuteLocalStorage();
        }, intervalTime);
      } else {
        window.spnGlobalConfig.batchedBeaconExecutionStart = true;
      }
    }
  } catch (error) {
    log(error);
  }
};

/**
 * I'm trying to get the last stored data from the local storage and send it to the server.
 * I'm using the following code to get the last stored data:
 */

const batchedExecuteLastSessionData = () => {
  try {
    const sessionId = SESSION_STORAGE_TYPE.batched + getAppSessionId();
    const analyticsKeyList = getKeyNameStoreData(
      SESSION_KEY_STORAGE_TYPE.batched
    );
    const allLastSessionKey = [];
    if (analyticsKeyList) {
      const analyticsKeyListArr = JSON.parse(analyticsKeyList);
      if (
        Array.isArray(analyticsKeyListArr) &&
        analyticsKeyListArr.length > 0
      ) {
        analyticsKeyListArr.forEach((key) => {
          if (sessionId !== key) {
            allLastSessionKey.push(key);
          }
        });
      }
    }
    batchedHandleEachLastSessionData(allLastSessionKey);
  } catch (error) {
    log(error);
  }
};

const batchedHandleEachLastSessionData = (allLastSessionKey) => {
  try {
    if (!window.spnGlobalConfig.spnBeaconNetworkStatus) {
      return;
    }
    if (!allLastSessionKey || allLastSessionKey.length == 0) {
      return;
    }

    const eachLastSessionKey = allLastSessionKey[0];
    const lastStoredata = localStorage.getItem(eachLastSessionKey);
    const eachLastSessionDataArr = lastStoredata
      ? JSON.parse(lastStoredata)
      : [];

    if (eachLastSessionDataArr.length == 0) {
      batchedRemoveSessionKey(eachLastSessionKey, allLastSessionKey);
      return;
    }

    const currentTime = parseInt(eachLastSessionDataArr[0].currentTime);
    const payLoadBody = eachLastSessionDataArr[0].payLoadBody;
    const eventType = eachLastSessionDataArr[0].eventType;
    const offlineCacheNextDate = getNextDateTime(
      currentTime,
      batchOfflineCacheFlushInterval
    );
    // offline cache time calculate
    if (currentTime > offlineCacheNextDate) {
      // remove from queue when current time greater then offline time
      const apiResponse = 200;
      batchedCleanEachBeacons(apiResponse, eachLastSessionKey);
      batchedHandleNextBeaconExecute(
        apiResponse,
        eachLastSessionKey,
        allLastSessionKey
      );
    } else {
      const networkPromise = postBeacon(payLoadBody, eventType);
      networkPromise
        .then((apiResponse) => {
          batchedCleanEachBeacons(apiResponse, eachLastSessionKey);
          batchedHandleNextBeaconExecute(
            apiResponse,
            eachLastSessionKey,
            allLastSessionKey
          );
        })
        .catch((e) => {
          log(e);
          if (
            window.spnGlobalConfig.spnBeaconNetworkStatus ||
            window?.navigator?.onLine
          ) {
            const apiResponse = 0;
            batchedCleanEachBeacons(apiResponse, eachLastSessionKey);
            batchedHandleNextBeaconExecute(
              apiResponse,
              eachLastSessionKey,
              allLastSessionKey
            );
          }
        });
    }
  } catch (e) {
    log(e);
  }
};

const batchedCleanEachBeacons = (apiResponse, eachLastSessionKey) => {
  try {
    if (apiResponse == 200 || apiResponse == 0) {
      const currentStoredata = localStorage.getItem(eachLastSessionKey);
      const eachLastSessionKeyData = currentStoredata
        ? JSON.parse(currentStoredata)
        : [];
      if (eachLastSessionKeyData.length > 0) {
        eachLastSessionKeyData.shift();
        updateStoreData(eachLastSessionKey, eachLastSessionKeyData);
      }
    }
  } catch (error) {
    log(error);
  }
};

const batchedHandleNextBeaconExecute = (
  apiResponse,
  eachLastSessionKey,
  allLastSessionKey
) => {
  try {
    if (apiResponse == 200 || apiResponse == 0) {
      window.spnGlobalConfig.maxRecordPerMinute += 1;
      // when beacons pass or fail
      const currentStoredata = localStorage.getItem(eachLastSessionKey);
      const localStorageData = currentStoredata
        ? JSON.parse(currentStoredata)
        : [];
      if (localStorageData.length > 0) {
        setTimeout(() => {
          batchedHandleEachLastSessionData(allLastSessionKey);
        }, 50);
      } else {
        batchedRemoveSessionKey(eachLastSessionKey, allLastSessionKey);
      }
    } else {
      batchedRemoveSessionKey(eachLastSessionKey, allLastSessionKey);
    }
  } catch (error) {
    log(error);
  }
};

const batchedRemoveSessionKey = (eachLastSessionKey, allLastSessionKey) => {
  if (localStorage.getItem(eachLastSessionKey)) {
    localStorage.removeItem(eachLastSessionKey);
  }
  batchedRemoveThisKeyFromList(eachLastSessionKey);
  allLastSessionKey.shift();
  batchedHandleEachLastSessionData(allLastSessionKey);
};

const batchedRemoveThisKeyFromList = (eachLastSessionKey) => {
  try {
    const analyticsKeyList = getKeyNameStoreData(
      SESSION_KEY_STORAGE_TYPE.batched
    );
    const analyticsKeyListData = analyticsKeyList
      ? JSON.parse(analyticsKeyList)
      : [];
    const keyPosition = analyticsKeyListData.indexOf(eachLastSessionKey);
    if (keyPosition > -1) {
      analyticsKeyListData.splice(keyPosition, 1);
      localStorage.setItem(
        SESSION_KEY_STORAGE_TYPE.batched,
        JSON.stringify(analyticsKeyListData)
      );
    }
  } catch (e) {
    log(e);
  }
  return true;
};

const getBatchRecordRemoveStatus = (apiResponse) => {
  let removeFromQueue = false;
  if (apiResponse == 0 && batchRemainingRetriesCount > 0) {
    removeFromQueue = false;
    batchRemainingRetriesCount -= 1;
  } else {
    removeFromQueue = true;
    batchRemainingRetriesCount = batchMaxRetriesCount - 1;
  }
  if (apiResponse == 200) {
    removeFromQueue = true;
    batchRemainingRetriesCount = batchMaxRetriesCount - 1;
  }
  if (batchDiscardOnFailure) {
    removeFromQueue = true;
  }
  return removeFromQueue;
};

export {
  batchedProcessQueue,
  batchedExecuteLocalStorage,
  batchedExecuteLastSessionData,
};
